import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MemberService } from 'src/app/core/service/member.service';

@Component({
  standalone: false,
  selector: 'app-opt-in',
  templateUrl: './opt-in.component.html',
  styleUrls: ['./opt-in.component.scss']
})
export class OptInComponent implements OnInit
{  
  public optedIn = false;
  public validating = true;
  public isValidToken = false;

  constructor(
    private memberService: MemberService,
    private route: ActivatedRoute
  ) { }

  public ngOnInit(): void
  {
    this.validating = true;
    this.isValidToken = false;
    this.route.params.forEach((params: Params) =>
    {
      if (params.token !== undefined)
      {
        this.memberService.optMemberBackIn(params.token).subscribe({
          next: (data) =>
          {
            if (data !== null && data !== undefined)
            {
              this.isValidToken = true;
              this.optedIn = true;
            }
            else
            {
              this.isValidToken = false;
            }
          },
          complete: () =>
          {
            this.validating = false;
          }
        });  
      }
    });
  }
}
